/**
 * Emailed OTP code validation (typed-OTP flows: AUTH-012 password reset,
 * AUTH-013 sign-up confirmation).
 *
 * The code length mirrors `otp_length = 6` pinned in supabase/config.toml —
 * validation runs client-side so no provider call is made for a malformed code.
 */

export const OTP_CODE_LENGTH = 6;

const OTP_CODE_REGEX = new RegExp(`^\\d{${OTP_CODE_LENGTH}}$`);

/** Keep only digits, clamped to the code length — applied on every keystroke. */
export function sanitizeOtpCodeInput(text: string): string {
  return text.replace(/\D/g, '').slice(0, OTP_CODE_LENGTH);
}

/** True only for exactly OTP_CODE_LENGTH digits. */
export function isValidOtpCode(code: string): boolean {
  return OTP_CODE_REGEX.test(code);
}
